import {
    checkForm,
    shouldActivateParsley
} from '../../../core/js/utils/errorHandling';
import {
    generate,
    templateLocationExists
} from '../../../core/js/utils/componentUtils';
import template from 'email-unsubscribe.j2';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import {
    submitEmailUnsubscribe,
    createUnsubscribeData
} from '../actions/helpActions';

/**
 * Attach component events to DOM
 * @param {object} store - The store
 */
function attachEvents(store) {
    $(document).on(this.scopedEvent('submit'), '.js-email-unsubscribe-form', (e) => {
        e.preventDefault();
        const email = $('.js-email-unsubscribe-email-address').val();

        store.dispatch(submitEmailUnsubscribe(email));
    });
}

/**
 * Activate parsley validation on the unsubscribe form
 * @param {object} component The current component
 * @param {object} store The redux store
 */
function activateParsley(component, store) {
    $(component.scopedSelector('.js-email-unsubscribe-form')).parsley().on('field:error', () => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-email-unsubscribe-form'));

        store.dispatch(createUnsubscribeData(values, msgs));
    });
}

function firstRender(store) {
    this.render(store, this, {});

    if (shouldActivateParsley('.js-email-unsubscribe-form')) {
        activateParsley(this, store);
    }
}

/**
 * Bootstrap the component onto the page
 * @param {object} store The redux store
 * @param {object} overrides Component-level override config
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        name: 'emailUnsubscribeComponentInit',
        attachEvents: attachEvents,
        isComponentValid: templateLocationExists,
        watch: 'help.emailUnsubscribe',
        replace: false,
        template: template,
        firstRender: firstRender,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        templateLocation: '.dom-email-unsubscribe',
        loader: {
            onWindow: true
        }
    };

    return generate(config, store, overrides);
}
